import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Mail, ArrowLeft, MailCheck } from "lucide-react";
import Btn from "../components/Btn";
import ThemeToggle from "../components/ThemeToggle";
import api, { apiErr } from "../lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-su-bg flex flex-col">
      <div className="p-4 flex items-center justify-between">
        <Link to="/auth" data-testid="forgot-back" className="flex items-center gap-2 font-heading font-extrabold text-su-muted hover:text-su-text">
          <ArrowLeft className="w-5 h-5" /> Masuk
        </Link>
        <ThemeToggle />
      </div>
      <div className="flex-1 grid place-items-center px-4 pb-10">
        <div className="w-full max-w-md">
          <div className="card-chunky p-6 sm:p-8 animate-pop" data-testid="forgot-card">
            {sent ? (
              <div className="text-center">
                <div className="w-14 h-14 rounded-2xl bg-su-success/20 grid place-items-center mx-auto mb-4">
                  <MailCheck className="w-7 h-7 text-su-success" />
                </div>
                <h1 className="font-heading font-black text-2xl text-su-text mb-2">Cek Emailmu 📬</h1>
                <p className="text-su-muted font-medium text-sm">
                  Jika <b className="text-su-text">{email}</b> terdaftar, kami sudah mengirim tautan reset password.
                  Tautan berlaku 1 jam. Cek folder spam bila tak muncul.
                </p>
                <Link to="/auth" className="inline-block mt-6">
                  <Btn data-testid="forgot-done" className="w-full">Kembali ke Masuk</Btn>
                </Link>
              </div>
            ) : (
              <>
                <h1 className="font-heading font-black text-2xl text-su-text mb-1">Lupa Password?</h1>
                <p className="text-su-muted font-medium text-sm mb-6">Masukkan emailmu, kami kirim tautan untuk reset password.</p>
                <form onSubmit={submit} className="space-y-3">
                  <div className="relative">
                    <Mail className="w-5 h-5 text-su-muted absolute left-4 top-1/2 -translate-y-1/2" />
                    <input
                      data-testid="forgot-email"
                      type="email"
                      placeholder="Email"
                      value={email}
                      required
                      onChange={(e) => setEmail(e.target.value)}
                      className="w-full pl-12 pr-4 py-3 rounded-2xl border-2 border-su-border bg-su-bg text-su-text font-medium outline-none focus:border-su-primary transition-colors"
                    />
                  </div>
                  <Btn data-testid="forgot-submit" type="submit" disabled={busy} className="w-full mt-2">
                    {busy ? "Mengirim..." : "Kirim Tautan Reset"}
                  </Btn>
                </form>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
